export const routes = {
	login: '/login',
	resetPassword: '/reset-password',
	forgotPassword: '/forgot-password',
	register: '/register',
	accountVerification: '/register/account-verification',
	updatePassword: '/update-password',

	dashBoard: '/app/dashboard',
	productDetails: '/app/product/:id',
	categoryProducts: '/app/category/:id',
    addToCart: '/app/checkout',

	profile: '/app/profile',
	changePassword: '/app/change-password',

	employees: '/app/employees',
	banners: '/app/banners',
	quicklinks: '/app/quicklinks',
	reports: '/app/reports',

	customers: '/app/customers',

	services: '/app/services',
	deals: '/app/deals',
	notification: '/app/notifications',
	
	employeePage: '/app/employee-page',

	stores: '/app/stores',
	review: '/app/review-rating',
	
	// promocodes: '/app/promocode',
	promocode: '/app/promocodes',
	generatePromocodes: '/app/generate-promocodes',

	excel: '/app/excel',

	promocodeValidate: "/app/promocode-validate",
	blogs:"/app/blogs",

	employeeLayout: "/employee-layout",
	shopkeeperLayout:"/shopkeeper-layout"
}
